module.exports = __webpack_public_path__ + "static/img/animales_09.ebbe7b75.jpg";